import React, { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import EmployeeProcessService from "../services/EmployeeProcessService"; // adjust path

const HolidayCalendar = () => {
  const empcode = localStorage.getItem('empcode');
  const [plantList, setPlantList] = useState([]);
  const [selectedPlantCode, setSelectedPlantCode] = useState("");
  const [year, setYear] = useState(new Date().getFullYear());
  const [events, setEvents] = useState([]);

  useEffect(() => {
    loadPlantList();
  }, []);

  const loadPlantList = async () => {
    try {
      const res = await  EmployeeProcessService.getPlant(empcode);
      if (res?.data?.statusCode === 200) {
        setPlantList(res.data.result);
      }
    } catch (error) {
      console.error("Error loading plant list:", error);
    }
  };

  const handleSearch = async () => {
    if (!selectedPlantCode) {
      alert("Please select a plant.");
      return;
    }

    try {
      const res = await EmployeeProcessService.getHolidayCalendar(selectedPlantCode, year);
      if (res?.data?.statusCode === 200) {
        const holidayEvents = res.data.result.map((holiday) => ({
          title: holiday.holidayName,
          date: holiday.holidayDate,
          allDay: true,
        }));
        setEvents(holidayEvents);
      }
    } catch (error) {
      console.error("Error fetching holidays:", error);
    }
  };

  return (
    <div className="container mt-4">
      <h4>Plant-wise Holiday Calendar</h4>

      <div className="row mb-3">
        <div className="col-md-3">
          <label>Year</label>
          <input
            type="number"
            className="form-control"
            value={year}
            onChange={(e) => setYear(e.target.value)}
          />
        </div>
        <div className="col-md-3">
          <label>Plant</label>
          <select
            className="form-select"
            value={selectedPlantCode}
            onChange={(e) => setSelectedPlantCode(e.target.value)}
          >
            <option value="">Select Plant</option>
            {plantList.map((p) => (
              <option key={p.id} value={p.id}>
                {p.name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-2 d-flex align-items-end">
          <button className="btn btn-primary w-100" onClick={handleSearch}>
            Show Calendar
          </button>
        </div>
      </div>

      <FullCalendar
        plugins={[dayGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        events={events}
        height="auto"
      />
    </div>
  );
};

export default HolidayCalendar;